import axios from 'axios';

const list = (data) => axios.get('/logist/carInfo/list', data);
const save = (data) => axios.post('/logist/carInfo/save', data);
const del = (data) => axios.post('/logist/carInfo/delete', data); //delete

export default {
  list,
  save,
  del,
}


